import type {
  Media,
  QuoteCarouselComponentProps,
} from "@services/wordpress/wordpress.types";
import { CustomCarousel } from "./CustomCarousel.index";
import { Slider } from "./Slider/index";

interface Props extends Omit<QuoteCarouselComponentProps, "media"> {
  applyNewStyles?: boolean;
  media?: Media;
}

export const QuoteCarouselDisplay = ({
  acf_fc_layout,
  applyNewStyles = false,
  slides,
  index,
  media,
}: Props & { index: number }) => {
  const id = `quote-carousel-${index}`;

  return applyNewStyles ? (
    <Slider
      id={id}
      slides={slides}
    />
  ) : (
    <CustomCarousel
      acf_fc_layout={acf_fc_layout}
      id={id}
      media={media}
      slides={slides}
    />
  );
};
